import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export default function dictionaryReducer(state = initialState.dictionaries, action) {
  switch (action.type) {
    case types.LOAD_COUNTRIES_SUCCEEDED:
      return {
        ...state,
        countries: Object.assign([], { loading: false, loaded: true, ids: action.result })
      };
    case types.LOAD_SCORING_CATEGORY_OPTIONS_STARTED:
      return {
        ...state,
        scoringCategoryOptions: Object.assign([], action.payload, { loading: true })
      };

    case types.LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS:
      return {
        ...state,
        scoringCategoryOptions: Object.assign([], action.payload, { isLoaded: true, loading: false })
      };
    case types.LOAD_DIMENSION_PERIODS_SUCCESS:
      return {
        ...state,
        dimensionPeriods: Object.assign([], action.payload, { isLoaded: true })
      };
    case types.LOAD_GENDER_TYPES_SUCCEEDED:
      return {
        ...state,
        genderTypes: Object.assign([], { loaded: true, ids: action.result })
      };
    default:
      return state;
  }
}
